<div class="embedded-messages {{messageType}}" id="{{embeddedMessageId}}">
    <div class="embedded-messages-icon" [innerHTML]="icon" role="img" [attr.aria-label]="messageType"></div>
    <div class="embedded-messages-text">{{messageData}}</div>
    <button class="embedded-messages-link btn-link" id="button" (click)="onLinkClick()">{{messageLink}}</button>
</div>